import { GetConfiguration } from "../utils/config";
import Auth, { AuthDataType, IAuth} from '../types/auth';
import { User } from 'oidc-client';
import { handleErrorsForSSO, getHeadersForSSO } from './identityService';
import { ExportDataSearchModel } from "../models/exportData";

export function handleErrorsForDownload(response: Response, auth?: IAuth) {    
    if (!response.ok) {
        if (response.status === 401) //unauthorzied
        {
            console.log('Error console HandleError unauthorized ');
            if (auth)
                auth.userManager.signoutRedirect();
        } else {        
            console.log('handleErrors', response)
            throw Error(response.statusText);
        }
    }
    return response.arrayBuffer();
}

export const getDatiUtilizzo = (ip: string, authData: AuthDataType, user: User, model: ExportDataSearchModel): Promise<ArrayBuffer> => {
        
    console.log('getDatiUtilizzo body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/report/exportdata`
    console.log('getDatiUtilizzo', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForDownload(res))
        .then(result => {
            console.log(`getDatiUtilizzo ("${authData.user}") -> recuperati in lunghezza ${result.byteLength} dati utilizzo`);
            // console.log('getTelematicos recuperato json: ' + JSON.stringify(json));
            //const rv = json;
            //console.log('getDatiUtilizzo recuperate: ' + JSON.stringify(rv));
            return result;
        })
        .catch(error => {
            console.log('getDatiUtilizzo error:', error);
            throw error;
        });
}
